import type { DriftPolicy, FlagFamily, FlagScope, FlagType, PluginRisk, VersionStatus } from '../api';
import type { Tone } from './Tag';

export const RISK_LABELS: Record<PluginRisk, string> = { low: 'Faible', medium: 'Moyen', high: 'Élevé' };
export const RISK_TONES: Record<PluginRisk, Tone> = { low: 'green', medium: 'orange', high: 'red' };

export const VERSION_STATUS_LABELS: Record<VersionStatus, string> = {
  draft: 'Brouillon',
  published: 'Publiée',
  withdrawn: 'Retirée',
};
export const VERSION_STATUS_TONES: Record<VersionStatus, Tone> = {
  draft: 'gray',
  published: 'green',
  withdrawn: 'red',
};

export const DRIFT_LABELS: Record<DriftPolicy, string> = {
  'report-only': 'Signaler seulement (report-only)',
  enforce: 'Corriger la dérive (enforce)',
};

export const FLAG_TYPE_LABELS: Record<FlagType, string> = {
  boolean: 'booléen',
  string: 'texte',
  number: 'entier',
};
export const FLAG_FAMILY_LABELS: Record<FlagFamily, string> = {
  entitlement: 'Droit d’accès',
  rollout: 'Déploiement progressif',
  config: 'Configuration',
};
export const FLAG_FAMILY_HINTS: Record<FlagFamily, string> = {
  entitlement: 'ouvre ou ferme une fonction (ex. plugin.kanban)',
  rollout: 'déploiement progressif par utilisateur, canal ou pourcentage',
  config: 'valeur de configuration (modèle par défaut, quota, texte)',
};

/** Du plus prioritaire au moins prioritaire : c'est l'ordre de résolution d'un flag pour une instance. */
export const SCOPE_ORDER: FlagScope[] = ['instance', 'user', 'channel', 'global'];
export const SCOPE_LABELS: Record<FlagScope, string> = {
  instance: 'Instance',
  user: 'Utilisateur',
  channel: 'Canal',
  global: 'Globale',
};

export const STATE_LABELS = { ok: 'OK', degraded: 'Dégradé', failed: 'En échec' } as const;
export const STATE_TONES = { ok: 'green', degraded: 'orange', failed: 'red' } as const;
